export const TODO_TOOL_NAME = 'todo';

export const CREATE_TODO_PLAN_TOOL_NAME = 'create_todo_plan';

export type AgentTodoOperation =
  | 'set'
  | 'create'
  | 'get'
  | 'update'
  | 'complete'
  | 'delete';

export type AgentTodoItemStatus = 'pending' | 'in_progress' | 'completed' | 'cancelled';

export interface AgentTodoItem {
  id: number;
  title: string;
  notes?: string;
  status: AgentTodoItemStatus;
}

export interface TodoState {
  planTitle: string | null;
  items: AgentTodoItem[];
}

export interface ParsedAgentTodoResult {
  items: AgentTodoItem[];
  /** Trailing plain-text banner from the BE (e.g. "All assigned steps are complete."). */
  banner?: string;
}
